module.exports = __webpack_public_path__ + "static/manual_of_quickness_of_action-98b883236f8fbad149948774985957cf.jpeg";